/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * 
 * This file is automatically generated by scripts/extract-chat-translations.js
 * To regenerate, run: npm run extract-chat-translations
 * 
 * Generated on: 2026-08-23T15:08:13.663Z
 * Total strings: 55
 */

export const DEFAULT_CHAT_TRANSLATION_JSON = {
  "A copy of the chat will be sent to {CLIENT_EMAIL}": "",
  "Agent is requesting a co-browsing session with you, do you want to accept?": "",
  "Agent is typing a message...": "",
  "Agent {AGENT_NAME} is accepting video call from {CLIENT_NAME}": "",
  "Agent {AGENT_NAME} is unable to accept screen sharing at the moment.": "",
  "Agent {AGENT_NAME} is unable to accept video call at the moment.": "",
  "Agent {AGENT_NAME} starting screen sharing with {CLIENT_NAME}": "",
  "Agent {AGENT_NAME} stopped a co-browsing session.": "",
  "Agent {AGENT_NAME} stopped screen sharing with {CLIENT_NAME}": "",
  "Agent {AGENT_NAME} stopped screen sharing.": "",
  "Agent {AGENT_NAME} stopped the video call": "",
  "Agent(s) added: {AGENT_NAMES}": "",
  "Agent(s) removed: {AGENT_NAMES}": "",
  "Client ended the chat.": "",
  "Client is not accepting video chat.": "",
  "Client is not enabling video chat.": "",
  "Co-browsing session status": "",
  "Do you want to close current co-browsing session ?": "",
  "Enter full screen": "",
  "Exit full screen": "",
  "Hide video preview": "",
  "Please hold while we find an agent to assist you. Your current queue position is:": "",
  "Reconnecting, please wait ...": "",
  "Show video preview": "",
  "System": "",
  "The agent is requesting a video call with you, do you want to accept?": "",
  "The agent is unable to accept screen sharing at the moment": "",
  "The agent is unable to accept video call at the moment": "",
  "The agent wants to share screen with you, do you want to accept?": "",
  "The uploaded file has exceeded the max allowed size.": "",
  "This chat has expired.": "",
  "This chat session will expire soon due to inactivity.": "",
  "Video call request already accepted in another window": "",
  "We're sorry, an error occurred while uploading the file.": "",
  "Write your question...": "",
  "{AGENT_NAME} ended the chat.": "",
  "{AGENT_NAME} has left the chat.": "",
  "{AGENT_NAME} initiated a co-browsing session.": "",
  "{AGENT_NAME} joins the chat.": "",
  "{CLIENT_NAME} activated co-browsing": "",
  "{CLIENT_NAME} have requested a callback through phone number {PHONE}": "",
  "{CLIENT_NAME} have requested a callback through phone number {PHONE} at {TIME}, we will reach you at the appointed time.": "",
  "{CLIENT_NAME} is accepting video call from agent {AGENT_NAME}": "",
  "{CLIENT_NAME} is not accepting video call from agent {AGENT_NAME}": "",
  "{CLIENT_NAME} is starting a co-browsing with agent {AGENT_NAME}": "",
  "{CLIENT_NAME} is unable to accept screen sharing at the moment.": "",
  "{CLIENT_NAME} starting screen sharing with agent {AGENT_NAME}": "",
  "{CLIENT_NAME} stopped a co-browsing session with agent {AGENT_NAME}": "",
  "{CLIENT_NAME} stopped screen sharing": "",
  "{CLIENT_NAME} stopped screen sharing with agent {AGENT_NAME}": "",
  "{CLIENT_NAME} stopped the video call": "",
  "{FROM_AGENT} forwarded the chat to area {AREA_NAME}": "",
  "{FROM_AGENT} forwarded the chat to {TO_AGENT}": "",
  "{FROM_AGENT} handover the chat to agent": "",
  "{NAME} ended the chat.": ""
};

export const DEFAULT_CHAT_TRANSLATION = JSON.stringify(DEFAULT_CHAT_TRANSLATION_JSON)
  .replace('{"', '"')
  .replace('"}', '"')
  .split('",')
  .join('",\n');
